import useCustomHook from '@/hooks/useCustomHook';
import { deepClone } from '@/modules/objectUtils';
import { useEffect } from 'react';

export default function useStoryWithQuestionsActivity({ activityConf }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      screen: 'COVER',
      canRestart: false,
      activityConf: null,
      currentPage: null,
    },
    actions: {
      setActivityConf: (activityConf) => {
        actions.setState({ activityConf });
      },
      startGame: () => {
        actions.setState({
          screen: 'GAME',
        });
      },
      goToMainMenu: () => {
        actions.setState({
          screen: 'COVER',
          activityConf: null,
          canRestart: false,
        });
      },
      onFinishedActivity: () => {
        actions.setState({
          canRestart: true,
        });
      },
      setCurrentPage: (currentPage) => {
        actions.setState({
          currentPage,
        });
      },
    },
  });

  useEffect(() => {
    if (activityConf) {
      const currentActivityConf = deepClone(activityConf);

      if (!currentActivityConf.miniactivityType) {
        currentActivityConf.miniactivityType = 'quiz';
        currentActivityConf.correctness = true;
      }

      actions.setState({
        activityConf: currentActivityConf,
      });
    }
  }, [activityConf]);

  return { state, actions };
}
